import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  JustifyContent,
  Space,
} from '@gousto-internal/citrus-react'

import { MenuDeliveryDate } from 'routes/Menu/components/MenuDateRange/MenuDeliveryDate'
import { MenuPreferencesButton } from 'routes/Menu/components/MenuPreferences/MenuPreferencesButton'
import { SearchButton } from 'routes/Menu/components/Search/SearchButton/SearchButton'

import { MenuExperienceBackButton } from './MenuExperienceBackButton'

type MenuExperienceSubHeaderProps = {
  pathname?: string
  query: Record<string, unknown>
  shouldGoBackToBrowse: boolean
}

export const MenuExperienceSubHeader = ({
  pathname,
  query,
  shouldGoBackToBrowse,
}: MenuExperienceSubHeaderProps) => (
  <Box bg={Color.White} data-testid="menu-experience-subheader">
    <Box
      display={[Display.None, Display.None, Display.Block]}
      maxWidth="1600px"
      style={{ margin: '0 auto', padding: '10px 30px 10px' }}
    >
      <Box
        alignItems={AlignItems.Center}
        display={Display.Flex}
        justifyContent={JustifyContent.SpaceBetween}
      >
        <Box alignItems={AlignItems.Center} display={Display.Flex} flexShrink={0}>
          <Box
            alignItems={AlignItems.Center}
            data-testid="deliveryDetailsBackButton-desktop"
            display={Display.Flex}
            flexShrink={0}
            justifyContent={JustifyContent.Center}
          >
            <MenuExperienceBackButton
              pathname={pathname}
              query={query}
              shouldGoBackToBrowse={shouldGoBackToBrowse}
              variant="desktop"
            />
            <Space size={4} direction="horizontal" />
            <MenuDeliveryDate variant="desktop" />
          </Box>
        </Box>
        <Box paddingH={8} style={{ flex: '1 1 auto', maxWidth: '50%' }}>
          <SearchButton />
        </Box>
        <Box flexShrink={0}>
          <MenuPreferencesButton variant="desktop" />
        </Box>
      </Box>
    </Box>
    <Box
      alignItems={AlignItems.Center}
      bg={Color.White}
      display={[Display.Flex, Display.Flex, Display.None]}
      justifyContent={JustifyContent.SpaceBetween}
      paddingH={3}
      paddingV={4}
      paddingBottom={2}
    >
      <Box
        alignItems={AlignItems.Center}
        data-testid="deliveryDetailsBackButton-mobile"
        display={Display.Flex}
        justifyContent={JustifyContent.Center}
      >
        <MenuExperienceBackButton
          pathname={pathname}
          query={query}
          shouldGoBackToBrowse={shouldGoBackToBrowse}
          variant="mobile"
        />
        <Space size={4} direction="horizontal" />
      </Box>
      <Box width="100%">
        <SearchButton />
      </Box>
      <MenuPreferencesButton variant="mobile" />
    </Box>
  </Box>
)
